export class GlobalConstants {
    public static readonly SvgLinSettingsCollection = {
        defaultSettings: {
            "NullValue": {
                type: '', strokeDashArray: "0,0", x1: 0, y1: 0, x2: 0, y2: 0,
                style: "", color: "", strokewidth: '', stroke: ''
            },//line

            "Actual-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash

            "ActualClean-deepdive": {
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash

            "FinalForecast1-deepdive": {
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 3px; stroke: rgb(190, 75, 72)", color: "#BE4B48",
                strokewidth: '3px', stroke: 'rgb(190, 75, 72)'
            },//dot line --
            "FinalForecast2-deepdive": {
                type: 'dash', strokeDashArray: "5,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#BE4B48", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash 
            // "FinalForecast3-deepdive": {
            //   type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
            //   style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px', stroke: 'rgb(190, 75, 72)',
            //   color: "#BE4B48"
            // },//line


            "ReleasedForecast-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 27, y1: 14, x2: 1, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#BE4B48", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//space dash line --

            "Min-deepdive": {
                type: 'full', strokeDashArray: "5,5", x1: 25, y1: 9, x2: 1, y2: 9,
                style: "stroke-width: 2px; stroke: rgb(255,255,255)", color: "white"

            },//box
            "Max-deepdive": {
                type: 'full', strokeDashArray: "5,5", x1: 25, y1: 9, x2: 1, y2: 9,
                style: "stroke-width: 2px; stroke: rgb(175, 176, 180)", color: "#AFB0B4"

            },//box

            "Actual-1-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//doted line  
            "Actual-2-deepdive": {
                type: 'dash', strokeDashArray: "5,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash line -- 
            "Actual-3-deepdive": {
                type: 'dash', strokeDashArray: "1,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//line

            "FinalForecast3-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)', color: "#BE4B48"
            },//line
            "Actual Sales LY-deepdive": {
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 3px; stroke: rgb(190, 75, 72)", color: "#BE4B48",
                strokewidth: '3px', stroke: 'rgb(190, 75, 72)'
            },//dot line -- 
            "Actual Sales-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px', stroke: 'rgb(190, 75, 72)',
                color: "#BE4B48"
            },//line 
        },

        statisticalForecastingSettings: {
            "Actual-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px', stroke: 'rgb(190, 75, 72)',
                color: "#BE4B48"
            },//line 
            "Actual Clean-deepdive": {
                type: 'dash', strokeDashArray: "1,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash
            "Forecast Algo-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px', stroke: 'rgb(190, 75, 72)',
                color: "#ff0000"
            },
            "Forecast Current-deepdive": {
                type: 'dash', strokeDashArray: "1,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#ff0000", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },
            "Month-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#ff0000", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },




            "NullValue": {
                type: '', strokeDashArray: "0,0", x1: 0, y1: 0, x2: 0, y2: 0,
                style: "", color: "", strokewidth: '', stroke: ''
            },//line


            "ActualClean-deepdive": {
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash

            "FinalForecast1-deepdive": {
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 3px; stroke: rgb(190, 75, 72)", color: "#BE4B48",
                strokewidth: '3px', stroke: 'rgb(190, 75, 72)'
            },//dot line --
            "FinalForecast2-deepdive": {
                type: 'dash', strokeDashArray: "5,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#BE4B48", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash 
            // "FinalForecast3-deepdive": {
            //   type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
            //   style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px', stroke: 'rgb(190, 75, 72)',
            //   color: "#BE4B48"
            // },//line


            "ReleasedForecast-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 27, y1: 14, x2: 1, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#BE4B48", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//space dash line --

            "Min-deepdive": {
                type: 'full', strokeDashArray: "5,5", x1: 25, y1: 9, x2: 1, y2: 9,
                style: "stroke-width: 2px; stroke: rgb(255,255,255)", color: "white"

            },//box
            "Max-deepdive": {
                type: 'full', strokeDashArray: "5,5", x1: 25, y1: 9, x2: 1, y2: 9,
                style: "stroke-width: 2px; stroke: rgb(175, 176, 180)", color: "#AFB0B4"

            },//box

            "Actual-1-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//doted line  
            "Actual-2-deepdive": {
                type: 'dash', strokeDashArray: "5,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash line -- 
            "Actual-3-deepdive": {
                type: 'dash', strokeDashArray: "1,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//line

            "Actual Clean 1-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//doted line  
            "Actual Clean 2-deepdive": {
                type: 'dash', strokeDashArray: "5,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash line -- 
            "Actual Clean 3-deepdive": {
                type: 'dash', strokeDashArray: "1,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//line

            "FinalForecast3-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)', color: "#BE4B48"
            },//line
            "Actual Sales LY-deepdive": {
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 3px; stroke: rgb(190, 75, 72)", color: "#BE4B48",
                strokewidth: '3px', stroke: 'rgb(190, 75, 72)'
            },//dot line -- 
            "Actual Sales-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px', stroke: 'rgb(190, 75, 72)',
                color: "#BE4B48"
            },//line 
            "ForecastClean-deepdive": {
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash
            "Forecast-deepdive": {
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px', stroke: 'rgb(190, 75, 72)',
                color: "#BE4B48"
            },//line 
        },

        defaultSettingsNew: [
            {
            name:"nullvalue", Value:"nullvalue",
            type: '', strokeDashArray: "0,0", x1: 0, y1: 0, x2: 0, y2: 0,
            style: "", color: "", strokewidth: '', stroke: ''
            },//line
             {
                name:"actual-deepdive", Value:"actual-deepdive",
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash

              {
                name:"actualclean-deepdive", Value:"actualclean-deepdive",
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash

             {
                name:"finalforecast1-deepdive", Value:"finalforecast1-deepdive",
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 3px; stroke: rgb(190, 75, 72)", color: "#BE4B48",
                strokewidth: '3px', stroke: 'rgb(190, 75, 72)'
            },//dot line --
             {
                name:"finalforecast2-deepdive", Value:"finalforecast2-deepdive",
                type: 'dash', strokeDashArray: "5,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#BE4B48", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash  


              {
                name:"releasedforecast-deepdive", Value:"releasedforecast-deepdive",
                type: 'dash', strokeDashArray: "0,0", x1: 27, y1: 14, x2: 1, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#BE4B48", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//space dash line --

              {
                name:"min-deepdive", Value:"minvalue-deepdive",
                type: 'full', strokeDashArray: "5,5", x1: 25, y1: 9, x2: 1, y2: 9,
                style: "stroke-width: 2px; stroke: rgb(255,255,255)", color: "white"

            },//box
             {
                name:"max-deepdive", Value:"maxvalue-deepdive",
                type: 'full', strokeDashArray: "5,5", x1: 25, y1: 9, x2: 1, y2: 9,
                style: "stroke-width: 2px; stroke: rgb(175, 176, 180)", color: "#AFB0B4"

            },//box 
             {
                name:"actual-1-deepdive", Value:"act1pct-deepdive",
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//doted line  
              {
                name:"actual-2-deepdive", Value:"act2pct-deepdive",
                type: 'dash', strokeDashArray: "5,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash line -- 
             {
                name:"actual-3-deepdive", Value:"act3pct-deepdive",
                type: 'dash', strokeDashArray: "1,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke:rgb(13, 71, 89);stroke-width:2", color: "#0D4759", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//line
             {
                name:"finalforecast3-deepdive", Value:"finalforecast3-deepdive",
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)', color: "#BE4B48"
            },//line
            {
                name:"finalforecast3-deepdive", Value:"fcpct-deepdive",
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)', color: "#BE4B48"
            },//line
             {
                name:"actual sales ly-deepdive", Value:"actualsalesly-deepdive",
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 3px; stroke: rgb(190, 75, 72)", color: "#BE4B48",
                strokewidth: '3px', stroke: 'rgb(190, 75, 72)'
            },//dot line -- 
             {
                name:"actual sales-deepdive", Value:"actualsales-deepdive",
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px', stroke: 'rgb(190, 75, 72)',
                color: "#BE4B48"
            },//line 

            {
                name:"finalforecast1-deepdive", Value:"final1-deepdive",
                type: 'dash', strokeDashArray: "3,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 3px; stroke: rgb(190, 75, 72)", color: "#BE4B48",
                strokewidth: '3px', stroke: 'rgb(190, 75, 72)'
            },//dot line --
             {
                name:"finalforecast2-deepdive", Value:"final2-deepdive",
                type: 'dash', strokeDashArray: "5,5", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#BE4B48", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//dash  
            {
                name:"finalforecast3-deepdive", Value:"final3-deepdive",
                type: 'dash', strokeDashArray: "0,0", x1: 1, y1: 14, x2: 20, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)', color: "#BE4B48"
            },//line
              {
                name:"releasedforecast-deepdive", Value:"released-deepdive",
                type: 'dash', strokeDashArray: "0,0", x1: 27, y1: 14, x2: 1, y2: 14,
                style: "stroke-width: 2px; stroke: rgb(190, 75, 72)", color: "#BE4B48", strokewidth: '2px',
                stroke: 'rgb(190, 75, 72)'
            },//space dash line --

        ] 
    }
}